var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('AddOnSelection',{attrs:{"hide-header":"","add-ons":_vm.addOns,"loading":_vm.loading},on:{"purchaseAddOn":_vm.redirectToPlanManagement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }